import { render, staticRenderFns } from "./EmployeeToPrimaryAssignmentBar.vue?vue&type=template&id=da08e40c&scoped=true"
import script from "./EmployeeToPrimaryAssignmentBar.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeToPrimaryAssignmentBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeeToPrimaryAssignmentBar.vue?vue&type=style&index=0&id=da08e40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da08e40c",
  null
  
)

export default component.exports